import { createAction } from 'redux-actions';

export const showNotification = createAction('SHOW_NOTIFICATION');
export const clearNotifications = createAction('CLEAR_NOTIFICATIONS');
